// we need our modal component
import CommonModal from '@/components/common/CommonModal';
import CommonToast from '@/components/common/CommonToast';
import CommonProgressBar from '@/components/common/ProgressBar';
import CommonAudio from '@/components/common/CommonAudio';
import CommonFooter from '@/components/common/CommonFooter';

export const Modal = {
  install(Vue, options) {
    this.EventBus = new Vue();
    // making our modal component global
    Vue.component('common-modal', CommonModal);

    // exposing global $modal object with method show()
    // method show() takes object params as argument
    // inside this object we can have modal title, text, styles... and also our callback confirm function
    Vue.prototype.$modal = {
      show(params) {
        // if we use this.$modal.show(params) inside our original Vue instance
        // we will emit 'show' event with parameters 'params'
        Modal.EventBus.$emit('show', params);
      },
    };
  },
};

export const Toast = {
  install(Vue, options) {
    this.EventBus = new Vue();
    Vue.component('common-toast', CommonToast);
    Vue.prototype.$toast = {
      showAlert(params) {
        Toast.EventBus.$emit('show', { ...params, type: 'alert' });
      },
      showInfo(params) {
        Toast.EventBus.$emit('show', { ...params, type: 'info' });
      },
      showWarning(params) {
        Toast.EventBus.$emit('show', { ...params, type: 'warning' });
      },
    };
  },
};

export const ProgressBar = {
  install(Vue, options) {
    this.EventBus = new Vue();
    Vue.component('progress-bar', CommonProgressBar);

    Vue.prototype.$progressBar = {
      show() {
        ProgressBar.EventBus.$emit('show', true);
      },
      hide() {
        ProgressBar.EventBus.$emit('show', false);
      },
    };
  },
};

export const AlarmSound = {
  install(Vue, options) {
    this.EventBus = new Vue();
    Vue.component('alarm-sound', CommonAudio);

    Vue.prototype.$alarmSound = {
      set(isEnable) {
        AlarmSound.EventBus.$emit('set', isEnable);
      },
    };
  },
};

export const FooterMsg = {
  install(Vue, options) {
    this.EventBus = new Vue();
    Vue.component('common-footer', CommonFooter);

    Vue.prototype.$footerMsg = {
      set(params) {
        FooterMsg.EventBus.$emit('set', params);
      },
    };
  },
};
